export default [
    {
        path: '/special/specialDetail/:id',
        name: 'SpecialDetail',
        component: () => import('@/views/special/SpecialDetail.vue'),
        meta: {
            showTab: false
        }
    },
]